module.exports = __webpack_public_path__ + "static/media/BlackStar13_Main_preview.c0175247.jpg";